'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moduleName = undefined;

var _mapConstants = require('utils/map-constants');

var _mapConstants2 = _interopRequireDefault(_mapConstants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moduleName = exports.moduleName = 'progresspopup';

var constants = ['SHOW', 'HIDE'];

exports.default = (0, _mapConstants2.default)({ moduleName: moduleName, constants: constants });


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/progresspopup.js
// module id = 2230
// module chunks = 1